import { render, staticRenderFns } from "./UserTag.vue?vue&type=template&id=3b2fcdee&scoped=true&"
import script from "./UserTag.vue?vue&type=script&lang=js&"
export * from "./UserTag.vue?vue&type=script&lang=js&"
import style0 from "./UserTag.vue?vue&type=style&index=0&id=3b2fcdee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2fcdee",
  null
  
)

export default component.exports